// apps/smart-shikka-web/src/supportAccess.ts
// Server-authoritative support access truth (merge-gate correction):
// every support surface gates on GET /api/support/access — the resolved
// capability grant, never the browser-visible login role.
import { useEffect, useState } from "react";
import { useAuth } from "./auth.js";
import { supportApi, type SupportAccessTruth } from "./api.js";

const CUSTOMER: SupportAccessTruth = { capability: "user", canUseInbox: false, canManageSla: false };

/**
 * Loads the server-resolved support capability once per mount. Fail-closed:
 * while loading or on error the caller is a plain customer (canUseInbox=false).
 */
export function useSupportAccess(): { access: SupportAccessTruth; loaded: boolean } {
  const { token } = useAuth();
  const [access, setAccess] = useState<SupportAccessTruth>(CUSTOMER);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!token) { setAccess(CUSTOMER); setLoaded(true); return; }
    let live = true;
    supportApi.access(token)
      .then((r) => { if (live) { setAccess(r.access); setLoaded(true); } })
      .catch(() => { if (live) { setAccess(CUSTOMER); setLoaded(true); } });
    return () => { live = false; };
  }, [token]);
  return { access, loaded };
}
